<header class="header d-flex align-items-center justify-content-between p-y-3 p-x-4 w-100">
  <div class="logo" (click)="navigateToMainPage()"></div>
  <div class="d-flex">
    <div class="header-action d-flex align-items-center justify-content-center default-border-radius"
         (click)="toggleMenu()">
      <lbt-icon size="lg" color="black-0">
        {{ isMenuOpened() ? 'close' : 'menu' }}
      </lbt-icon>
    </div>
  </div>
</header>

<ng-template #mainMenuTmpl>
<lbt-mobile-main-menu/>
</ng-template>
